import React from 'react';
import { PromoCodeRow } from 'subscriptionOptions/renewalPromoCodes';

type AppliedPromoCodesProps = {
  rows: PromoCodeRow[];
  /** Omitted where the codes are shown read-only. */
  onRemove?: (promoCode: string) => void;
  /** Codes a write displaced, and a wiped-code explanation. */
  dropped?: string[];
  wipedNotice?: string;
  /** Codes a quote named that have ended since it was made. */
  expired?: string[];
};

/** The codes the account holds for a basket, under the promo input that applies them. */
export const AppliedPromoCodes: React.FC<AppliedPromoCodesProps> = ({
  rows,
  onRemove,
  dropped,
  wipedNotice,
  expired,
}) => (
  <>
    {rows.length > 0 && (
      <div className="AppliedPromoCodes">
        {rows.map((row) => (
          <div className="APCRow" key={row.promoCode}>
            <div className="APCCode">
              {row.promoCode}
              {row.expiryDate && <span className="APCExpiry">Expires on {row.expiryDate}</span>}
              {row.priced && !row.applied && (
                <span className="APCNote">A larger discount is already applied</span>
              )}
            </div>
            <div className="APCValue">{row.applied ? '-£' + row.discount.toFixed(2) : '-'}</div>
            {onRemove && (
              <button
                className="APCRemove"
                type="button"
                aria-label={'Remove promo code ' + row.promoCode}
                onClick={() => onRemove(row.promoCode)}
              >
                &times;
              </button>
            )}
          </div>
        ))}
      </div>
    )}

    {dropped && dropped.length > 0 && (
      <div className="APCNotice">
        {dropped.join(', ')} {dropped.length > 1 ? 'are' : 'is'} no longer applied.
      </div>
    )}

    {expired && expired.length > 0 && (
      <div className="APCNotice">
        {expired.join(', ')} {expired.length > 1 ? 'have' : 'has'} expired and{' '}
        {expired.length > 1 ? 'are' : 'is'} no longer applied.
      </div>
    )}

    {wipedNotice && <div className="APCNotice">{wipedNotice}</div>}
  </>
);
